import { HTMLTagRegEx } from "../../../constants";
import { INTERNATIONAL } from "../constants";
import { IManageServiceFormModel, IServiceBackEndModel } from "../types";

export function parseManageServiceToBackEndModel(
  frontEndModel: IManageServiceFormModel,
): IServiceBackEndModel {
  const backEndModel: IServiceBackEndModel = {
    id: frontEndModel.id,
    serviceProviderId: frontEndModel.serviceProviderId,
    serviceProductType: frontEndModel.serviceType.id,
    countries: frontEndModel.countries
      .filter((c) => c.code !== INTERNATIONAL)
      .map((c) => c.code),
    details: [],
    detailFiles: [],
  };

  //Details ----------------------------------------------------
  Object.entries(frontEndModel.details).forEach(([key, value]) => {
    const typeId = +key.split("_")[1];

    if (value && String(value).replace(HTMLTagRegEx, "").trim().length) {
      backEndModel.details.push({
        type: typeId,
        content: String(value),
      });
    }
  });

  //Files ------------------------------------------------------
  if (frontEndModel.detailFiles?.length) {
    backEndModel.detailFiles = frontEndModel.detailFiles.map((file) => ({
      fileId: file.id,
    }));
  }

  return backEndModel;
}
